<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
    ></SearchField>

    <Table
      ref="table"
      :tableData="tableData"
      :cols="cols"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "Actionlog",
      breadcrumb: [{ name: "系统设置" }, { name: "操作日志" }],
      formInline: {},
      formCtrl: [
        {
          label: "操作人",
          keyName: "username",
          placeholder: "请填写操作人",
          type: "text",
        },
        {
          label: "操作时间：",
          keyName: "created_at",
          placeholder: "请选择时间",
          type: "datetimerange",
        },
        // {
        //   label: "登录状态",
        //   keyName: "success",
        //   type: "select",
        //   options: [
        //     { label: '登录成功', value: 1 },
        //     { label: '登录失败', value: 2 },
        //   ],
        // },
      ],
      cols: [
        { prop: "username", label: "操作人" },
        { prop: "module", label: "模块", minwidth: 60 },
        { prop: "method", label: "操作类型", minwidth: 40 },
        { prop: "description", label: "操作描述", minwidth: 200 },
        { prop: "ip", label: "IP" },
        { prop: "city", label: "城市" },
        { prop: "created_at", label: "操作时间" },
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id }) => {
            this.$router.push(`/system/operationDetail?mode=view&id=${id}`);
          },
        },
      ],
    };
  },
  methods: {},
};
</script>
